module.exports = __webpack_public_path__ + "img/monitorbox07.72814aa4.jpg";